module.exports = __webpack_public_path__ + "img/pv-01.8c0cf8d1.svg";